import { captureEvent, telegramNotify } from "./http";
import { openBrowserWindow, parseQueryString } from "./util";

import { createDropboxConfig } from "./fs";
import { lsKeyDropboxEmail } from "./user";
import { makeFileSystemDropbox } from "./fs-dropbox";

let dropbBoxClientID = "go8qowpuq9bmfqc"; // app key

interface DropboxUserName {
  abbreviated_name: string;
  display_name: string;
  familiar_name: string;
  given_name: string;
  surname: string;
}

interface DropboxUsersFullAccount {
  account_id: string;
  email: string;
  name: DropboxUserName;
  locale: string;
  email_verified: boolean;
  country: string;
}

export async function getDropboxClient(
  accessToken?: string,
  refreshToken?: string
) {
  // @ts-ignore
  let Dropbox = await import("https://esm.sh/dropbox@10.30.0");
  // console.log("Dropbox:", Dropbox);

  let opts: any = {
    clientId: dropbBoxClientID,
  };
  if (accessToken) {
    opts.accessToken = accessToken;
    opts.refreshToken = refreshToken;
  }
  return new Dropbox.Dropbox(opts);
}

// https://dropbox.github.io/dropbox-sdk-js/Dropbox.html#usersGetCurrentAccount__anchor
export async function dbxGetAccountInfo(
  accessToken: string,
  refreshToken: string
): Promise<DropboxUsersFullAccount> {
  console.log("dbxGetAccountInfo, tokens:", accessToken, refreshToken);
  const dbx = await getDropboxClient(accessToken, refreshToken);
  const ui = await dbx.usersGetCurrentAccount();
  return ui.result;
}

const lsKeyDrobBoxCodeVerifier = "fm-dropbox-code-verifier";
const lsKeyDropboxToken = "fm-dropbox-token";

const l = window.location;
export let dropboxRedirectURL =
  l.protocol + "//" + l.host + "/auth/dropboxlogin";

export async function connectDropbox(onConnected: (fs: any) => void) {
  let dbx = await getDropboxClient();
  let authURL = await dbx.auth.getAuthenticationUrl(
    dropboxRedirectURL,
    undefined,
    "code",
    "offline",
    undefined,
    undefined,
    true
  );
  let cv = dbx.auth.codeVerifier;
  console.log("connectDropbox: codeVerifier:", cv);
  localStorage.setItem(lsKeyDrobBoxCodeVerifier, cv);
  let storageListener = (e: StorageEvent) => {
    waitForDropboxToken(e, onConnected, storageListener);
  };
  window.addEventListener("storage", storageListener);
  openBrowserWindow(authURL, "Dropbox Login", 840, 760);
}

// will be called when localStorage is modified from a different window
// here we wait for dropbox token to be set
// triggered by completeDropboxAuth
async function waitForDropboxToken(
  e: StorageEvent,
  onConnected: (fs: any) => void,
  listener: (e: StorageEvent) => void
) {
  console.log("waitForDropboxToken", e);
  if (e.key !== lsKeyDropboxToken) {
    return;
  }
  window.removeEventListener("storage", listener);
  if (!e.newValue) return;
  const result = JSON.parse(e.newValue);
  const accessToken = result.access_token;
  const refreshToken = result.refresh_token;

  console.log("dropbox accessToken changed to:", accessToken);
  if (!accessToken) {
    // shouldn't happen
    return;
  }

  let c = createDropboxConfig();
  c.accessToken = accessToken;
  c.refreshToken = refreshToken;

  const ui = await dbxGetAccountInfo(accessToken, refreshToken);
  c.email = ui.email;
  c.name = ui.name.display_name;

  const msg = `New Dropbox connection for ${ui.email}`;
  telegramNotify(msg);
  captureEvent("dropbox-login", {
    email: ui.email,
  });
  localStorage.setItem(lsKeyDropboxEmail, ui.email);

  localStorage.removeItem(lsKeyDropboxToken);
  localStorage.removeItem(lsKeyDrobBoxCodeVerifier);

  const fs = await makeFileSystemDropbox(c);
  onConnected(fs);
}

// called from index.html
export async function completeDropboxAuth() {
  console.log("completeDropboxAuth: location.search:", window.location.search);
  let code = parseQueryString(window.location.search).code;
  const dbx = await getDropboxClient();
  let cv = localStorage.getItem(lsKeyDrobBoxCodeVerifier);
  console.log("codeVerifier:", cv);
  dbx.auth.setCodeVerifier(cv);
  let rsp = await dbx.auth.getAccessTokenFromCode(dropboxRedirectURL, code);
  console.log("completeDropboxAuth: onResponse: result:", rsp.result);
  let js = JSON.stringify(rsp.result);
  // this will trigger waitForDropboxToken in original window
  localStorage.setItem(lsKeyDropboxToken, js);
  window.close();
}
